import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnPeopleGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M17.329 11.114a2.55 2.55 0 0 0 2.195-2.523c0-1.268-.925-2.32-2.137-2.518m1.576 8.018c1.2.18 2.037.6 2.037 1.465 0 .596-.394.983-1.032 1.226M6.671 11.115A2.55 2.55 0 0 1 4.477 8.59c0-1.268.924-2.32 2.136-2.518m-1.576 8.018c-1.2.18-2.037.6-2.037 1.465 0 .596.394.983 1.032 1.226M12 14.458c-2.854 0-5.291.433-5.291 2.16 0 1.726 2.422 2.17 5.29 2.17 2.854 0 5.29-.427 5.29-2.155s-2.42-2.175-5.29-2.175m0-2.464A3.39 3.39 0 1 0 8.61 8.603a3.377 3.377 0 0 0 3.366 3.39z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnPeopleGroup;
